import React from 'react';

export default function AircraftFleetCard({
  aircraft,
  statusMeta,
  openDefects,
  isExpanded,
  isBusy,
  isWbExpanded,
  appSettings,
  onRecordingMethodChange,
  onPhotoUpload,
  onToggleWb,
  onToggleReview,
  onRemove,
}) {
  const a = aircraft;

  return (
    <div
      style={{
        background: '#1a2338',
        border: `1px solid ${statusMeta.border}`,
        borderRadius: 14,
        padding: '1rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 20,
          alignItems: 'center',
        }}
      >
        <div
          style={{
            flex: '0 0 170px',
            width: '170px',
            maxWidth: '100%',
          }}
        >
          {a.image_url ? (
            <img
              src={a.image_url}
              alt={`${a.registration} aircraft`}
              style={{
                width: '100%',
                height: 110,
                objectFit: 'cover',
                borderRadius: 12,
                border: '1px solid #35507f',
                display: 'block',
                boxShadow:
                  '0 10px 24px rgba(0,0,0,0.25)',
              }}
            />
          ) : (
            <div
              style={{
                width: '100%',
                height: 110,
                borderRadius: 12,
                border: '1px solid #35507f',
                background:
                  'linear-gradient(135deg, #16233a, #0f1828)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#8db7e6',
                fontWeight: 800,
                fontSize: '0.8rem',
              }}
            >
              No photo
            </div>
          )}
        </div>

        <div
          style={{
            minWidth: 0,
            flex: '1 1 320px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 12,
              alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            <div>
              <div
                style={{
                  color: '#eaf6ff',
                  fontWeight: 900,
                  fontSize: '1.25rem',
                }}
              >
                {a.registration}

                <span
                  style={{
                    color: '#8db7e6',
                    marginLeft: 8,
                    fontSize: '0.95rem',
                  }}
                >
                  {a.icao_type}
                </span>
              </div>

              <div
                style={{
                  color: '#d7ebff',
                  marginTop: 8,
                  fontSize: '0.95rem',
                }}
              >
                <span
                  style={{
                    color: statusMeta.text,
                    fontWeight: 800,
                  }}
                >
                  {statusMeta.icon}{' '}
                  {String(statusMeta.label || '')
                    .charAt(0)
                    .toUpperCase() +
                    String(statusMeta.label || '')
                      .slice(1)
                      .toLowerCase()}
                </span>

                <span
                  style={{
                    color: '#8db7e6',
                    marginLeft: 10,
                  }}
                >
                  Open defects: {openDefects.length}
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              gap: 8,
              flexWrap: 'wrap',
              alignItems: 'stretch',
              marginTop: 18,
              overflow: 'hidden',
            }}
          >
            <select
              value={
                a.recording_method ||
                appSettings?.techLog?.recordingMethod ||
                'hobbs'
              }
              onChange={(event) =>
                onRecordingMethodChange(
                  a.id,
                  a.registration,
                  event.target.value
                )
              }
              aria-label={`Recording method for ${a.registration}`}
              style={{
                ...controlStyle,
                flex: '1 1 120px',
                minWidth: 120,
                border: '1px solid #1ecfff',
                background: '#1a2338',
                color: '#b6eaff',
                fontWeight: 500,
              }}
            >
              <option value="hobbs">Hobbs</option>
              <option value="datcon">Datcon</option>
              <option value="tacho">Tacho</option>
            </select>

            <label
              style={{
                ...controlStyle,
                height: 40,
                flex: '1 1 145px',
                minWidth: 145,
                background: '#9ed0ff',
                color: '#10233a',
                cursor: 'pointer',
                fontWeight: 800,
                fontFamily: 'inherit',
                lineHeight: 1,
                paddingTop: 0,
                paddingBottom: 0,
                boxSizing: 'border-box',
              }}
            >
              {a.image_url
                ? 'Change photo'
                : 'Add photo'}

              <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={(event) => {
                  const file =
                    event.target.files?.[0];

                  if (file) {
                    onPhotoUpload(a, file);
                  }

                  event.target.value = '';
                }}
              />
            </label>

            <button
              type="button"
              onClick={() => onToggleWb(a)}
              style={{
                ...smallButtonStyle,
                flex: '1 1 96px',
                minWidth: 96,
              }}
            >
              {isWbExpanded ? 'Hide W&B' : 'W&B'}
            </button>

            <button
              type="button"
              onClick={onToggleReview}
              disabled={isBusy}
              style={{
                ...smallButtonStyle,
                flex: '1 1 96px',
                minWidth: 96,
                opacity: isBusy ? 0.65 : 1,
                cursor: isBusy
                  ? 'wait'
                  : 'pointer',
              }}
            >
              {isExpanded ? 'Hide' : 'Review'}
            </button>

            <button
              type="button"
              onClick={onRemove}
              style={{
                ...dangerButtonStyle,
                flex: '1 1 96px',
                minWidth: 96,
              }}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const controlStyle = {
  minHeight: 40,
  boxSizing: 'border-box',
  borderRadius: 8,
  padding: '0.45rem 0.7rem',
  border: 'none',
  fontSize: '0.82rem',
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1.2,
};

const smallButtonStyle = {
  ...controlStyle,
  background: '#9ed0ff',
  color: '#10233a',
  fontWeight: 800,
  cursor: 'pointer',
};

const dangerButtonStyle = {
  ...smallButtonStyle,
  background: '#ff7c7c',
  color: '#290707',
};